<template>
  <div class="step-back">
      <img class="icon"
           v-if="checkIfThemeIsActive(availableThemes.Kabel24)"
           :src="publicImage('themes/kabel24/chevron-down-primary.svg')"
           alt="chevron_left"
           :class="getActiveTheme"
      />
      <img v-else class="icon" :src="publicImage('themes/elektramat/arrow-blue-left.svg')" alt=""/>
    <button @click="goBackOneStep" class="btn text">
      {{ $t('global.word.step_back') }}
    </button>
  </div>

</template>

<script>
import {mapActions, mapGetters} from 'vuex';

export default {
  name: 'LinkStepBack',

  computed: {
    ...mapGetters({
      checkIfThemeIsActive: 'theme/checkIfThemeIsActive',
      getActiveTheme: 'theme/getActiveTheme',
      availableThemes: 'theme/getAvailableThemes'
    }),
  },
  methods: {
    ...mapActions('preference', [
      'goBackOneStep',
    ]),
  },
};
</script>

<style scoped lang="scss">

.step-back {
  display: flex;
  align-items: center;
}

.icon {
  margin-right: 10px;
  width: 10px;
  position: relative;
  top: -1px;

  &.kabel-24 {
    transform: rotate(90deg);
  }
}

button {
  font-size: 12px;
  background: none;
  border: none;
  padding: 0;
  color: #069;
  text-decoration: underline;
  cursor: pointer;
}
</style>
